import { Flex, Text } from "@mantine/core";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

import type { FC } from "react";

interface Props {
  auctionDate: string | undefined;
}

const AuctionCountdown: FC<Props> = ({ auctionDate }) => {
  const { t } = useTranslation();

  /* Constants */
  const isToday = auctionDate ? dayjs(auctionDate).isSame(dayjs(), "day") : false;
  const daysUntilAuction = auctionDate
    ? Math.max(0, dayjs(auctionDate).startOf("day").diff(dayjs().startOf("day"), "day"))
    : 0;

  return (
    <Flex
      pos="absolute"
      top={0}
      left={0}
      w="100%"
      h={120}
      justify="center"
      align="center"
      direction="column"
      style={{ zIndex: 1 }}
      gap="xs"
    >
      <Text size="0.75em" c="white" fw={500} style={{ visibility: isToday ? "hidden" : "visible" }}>
        {t("components.Auctions.arrivingIn")}
      </Text>

      <Text size="1.75em" c="white" fw={400}>
        {isToday
          ? t("components.Auctions.today")
          : `${daysUntilAuction} ${t("components.Auctions.days")}`}
      </Text>
    </Flex>
  );
};

export default AuctionCountdown;
